module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/tfl_skype_unsupported.2de935a33a8e53472500a8de753023c1.png";